<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title17"></a>
<div class="p-c"><span><em class="i"><strong class="b">For my son, Nicholas</strong></em></span></div>
<div class="illustype_image_text"><div class="image_text"><img alt="e9781466806603_i0002.jpg" src="e9781466806603_i0002.jpg"/></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466806603_ded01.vue?a7f18114